module.exports = __webpack_public_path__ + "static/media/executive2.f94c6a05.webp";